module.exports = __webpack_public_path__ + "static/img/nav_bg.72e0257b.png";